<template>
  <div class="row mb-4">
    <div class="col-xxl-12">
      <UsersList />
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-xxl-12">
      <CamerasList />
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import UsersList from "../../components/Users/UsersList.vue";
import CamerasList from "../../components/Users/CamerasList.vue";
import { mapActions } from 'vuex';

export default defineComponent({
  name: "UsersPage",
  components: {
    UsersList,
    CamerasList
  },
  methods: {
    ...mapActions([
      "setUsersForCompanyId",
      "setCamerasByCompanyId",
      "resetUsersForCompanyId",
      "resetCamerasByCompanyId"
    ]),
  },
  mounted() {
    if(this.$route.params.installation_id != null){
      this.setUsersForCompanyId(this.$route.params.installation_id);
      this.setCamerasByCompanyId(this.$route.params.installation_id);
    }
  },
  unmounted() {
      this.resetUsersForCompanyId();
      this.resetCamerasByCompanyId();
  },
});
</script>